import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconSizes } from '../../../components/foundations/Icon';
import css from './UnsupportedArtifact.css';

const UnsupportedArtifact = ({ artifact }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className={css.placeholder}>
            <div
                className={css.placeholderHeader}
                onClick={() => setIsExpanded(!isExpanded)}
                style={{ cursor: 'pointer' }}
            >
                <Icon name="question-circle" size={IconSizes.LARGE} />
                <div className={css.placeholderTitle}>Unsupported Artifact Type</div>
                <div className={css.placeholderText}>Type: {artifact.type}</div>
                <Icon name={isExpanded ? 'chevron-up' : 'chevron-down'} size={IconSizes.SMALL} />
            </div>
            {isExpanded && <pre className={css.placeholderData}>{JSON.stringify(artifact, null, 2)}</pre>}
        </div>
    );
};

UnsupportedArtifact.propTypes = {
    artifact: PropTypes.shape({
        type: PropTypes.string,
    }).isRequired,
};

export default UnsupportedArtifact;
